import { invoke,invokeGet,invokePost } from "./serviceInvoker";
import { serviceURL } from "./global";

export async function fetchQrgenerator(request){
    try {
        const response = await invoke(serviceURL.generateQR, request, invokePost)
        return response;
    } catch (error) {
        console.log(error);
    }
}

export async function fetchQrEvents(request){
    try {
        const response = await invoke(serviceURL.eventsQR, request, invokeGet)
        return response;
    } catch (error) {
        console.log(error);
    }
}